import { createSlice, configureStore, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
    isMobile: boolean | null; 
}

const initialState: AuthState = {
    isMobile: null,
};
  

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setIsMobile(state: AuthState, action: PayloadAction<boolean>) {
      state.isMobile = action.payload;
    },
  },
});

export const { setIsMobile } = authSlice.actions;

export const store = configureStore({
    reducer: {
      auth: authSlice.reducer,
    },
});
  
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;